import { DEALERS_API_URL } from 'constants/ApiConstants';
import { INTERVENTIONS_API_URL } from 'constants/InterventionConstants';
import type { MetaAction } from 'modules/global/generic.types';

import * as types from '../actionTypes';
import type {
  SaveFollowUpConfigAction,
  SetStepDetailReadyAction,
  SaveFollowUpConfigPayload,
  PatchInterventionStepAction,
  PatchInterventionStepPayload,
  OpenFollowUpConfigModalAction,
  CloseFollowUpConfigModalAction,
  SaveFollowUpConfigFailureAction,
  SaveFollowUpConfigSuccessAction,
  SaveFollowUpConfigSuccessPayload,
  PatchInterventionStepFailureAction,
  PatchInterventionStepSuccessAction,
} from '../types/actions';

export const patchInterventionStep = (
  { interventionId, stepId, mode, userGroupId, userId, serviceAdvisorUserGroupId, serviceAdvisorUserId, notify }: PatchInterventionStepPayload,
  meta: MetaAction = {},
): PatchInterventionStepAction => ({
  type: types.CHANGE_INTERVENTION_STEP,
  payload: {
    request: {
      method: 'PATCH',
      url: `${INTERVENTIONS_API_URL[mode]}/${interventionId}/step`,
      params: { notify },
      data: {
        userId,
        stepId,
        userGroupId,
        serviceAdvisorUserId,
        serviceAdvisorUserGroupId,
      },
    },
  },
  meta,
});

export const patchInterventionStepSuccess = (payload: unknown, meta: MetaAction = {}): PatchInterventionStepSuccessAction => ({
  type: types.CHANGE_INTERVENTION_STEP_SUCCESS,
  payload,
  meta,
});

export const patchInterventionStepFailure = (meta: MetaAction = {}): PatchInterventionStepFailureAction => ({
  type: types.CHANGE_INTERVENTION_STEP_FAILURE,
  meta,
});

export const setStepDetailReady = (isReady: boolean, meta: MetaAction = {}): SetStepDetailReadyAction => ({
  type: types.SET_STEPS_DETAILS_READY,
  payload: isReady,
  meta,
});

export const openFollowUpConfigModal = (payload: unknown, meta: MetaAction = {}): OpenFollowUpConfigModalAction => ({
  type: types.OPEN_FOLLOW_UP_CONFIG_MODAL,
  payload,
  meta,
});

export const closeFollowUpConfigModal = (payload: unknown, meta: MetaAction = {}): CloseFollowUpConfigModalAction => ({
  type: types.CLOSE_FOLLOW_UP_CONFIG_MODAL,
  payload,
  meta,
});

export const saveFollowUpConfig = ({ dealerId, followUpConfig }: SaveFollowUpConfigPayload, meta: MetaAction = {}): SaveFollowUpConfigAction => ({
  type: types.SAVE_FOLLOW_UP_CONFIG,
  payload: {
    request: {
      method: 'PUT',
      url: `${DEALERS_API_URL}/${dealerId}/config/followUp`,
      data: followUpConfig,
    },
    dealerId,
  },
  meta,
});

export const saveFollowUpConfigSuccess = (payload: SaveFollowUpConfigSuccessPayload, meta: MetaAction = {}): SaveFollowUpConfigSuccessAction => ({
  type: types.SAVE_FOLLOW_UP_CONFIG_SUCCESS,
  payload,
  meta,
});

export const saveFollowUpConfigFailure = (message: string, meta: MetaAction = {}): SaveFollowUpConfigFailureAction => ({
  type: types.SAVE_FOLLOW_UP_CONFIG_FAILURE,
  payload: message,
  error: true,
  meta,
});
